/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountManagerDeleteRequest } from '../models/AccountManagerDeleteRequest';
import type { AccountManagerDeleteResponseApiRespoonse } from '../models/AccountManagerDeleteResponseApiRespoonse';
import type { AccountManagerListRequest } from '../models/AccountManagerListRequest';
import type { AccountManagerListResponseApiRespoonse } from '../models/AccountManagerListResponseApiRespoonse';
import type { AccountManagerRegisterRequest } from '../models/AccountManagerRegisterRequest';
import type { AccountManagerRegisterResponseApiRespoonse } from '../models/AccountManagerRegisterResponseApiRespoonse';
import type { AccountManagerShowRequest } from '../models/AccountManagerShowRequest';
import type { AccountManagerShowResponseApiRespoonse } from '../models/AccountManagerShowResponseApiRespoonse';
import type { AccountManagerUpdateRequest } from '../models/AccountManagerUpdateRequest';
import type { AccountManagerUpdateResponseApiRespoonse } from '../models/AccountManagerUpdateResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AccountManagerService {

    /**
     * List account
     * @param requestBody
     * @returns AccountManagerListResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAccount(
        requestBody: AccountManagerListRequest,
    ): CancelablePromise<AccountManagerListResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/account',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Register account
     * @param requestBody
     * @returns AccountManagerRegisterResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAccountCreate(
        requestBody: AccountManagerRegisterRequest,
    ): CancelablePromise<AccountManagerRegisterResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/account/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show account
     * @param requestBody
     * @returns AccountManagerShowResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAccountShow(
        requestBody: AccountManagerShowRequest,
    ): CancelablePromise<AccountManagerShowResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/account/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Update account
     * @param requestBody
     * @returns AccountManagerUpdateResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAccountEdit(
        requestBody: AccountManagerUpdateRequest,
    ): CancelablePromise<AccountManagerUpdateResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/admin/account/edit',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Update account
     * @param requestBody
     * @returns AccountManagerDeleteResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminAccountDelete(
        requestBody: AccountManagerDeleteRequest,
    ): CancelablePromise<AccountManagerDeleteResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/account/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
